import { ContentType, Method } from 'axios-mapper'
import https from '../utils/https'

export const getAffSiteMessage = (query) => {
  return https('affiliate').request(
    '/session/pm/inbox',
    Method.GET,
    query,
    ContentType.form
  )
}

export const readAffSiteMessage = (id) => {
  return https('affiliate').request(
    '/session/pm/inbox/read',
    Method.POST,
    { id },
    ContentType.form
  )
}

export const readMultipleAffSiteMessage = (ids) => {
  return https('affiliate').request(
    '/session/pm/inbox/readMultiple',
    Method.POST,
    { ids: ids.join(',') },
    ContentType.form
  )
}

export const deleteAffSiteMessage = (id) => {
  return https('affiliate').request(
    '/session/pm/inbox/delete',
    Method.POST,
    { id },
    ContentType.form
  )
}

export const deleteMultipleAffSiteMessage = (ids) => {
  return https('affiliate').request(
    '/session/pm/inbox/deleteMultiple',
    Method.POST,
    { ids: ids.join(',') },
    ContentType.form
  )
}

export const getUnreadSiteMessage = () => {
  return https('affiliate').request(
    '/session/pm/inbox/getUnreadTotal',
    Method.GET
  )
}
